import URLConfig from '../service/URLConfig';
import axiosInstance from "../util/axiosInstance";
const path = URLConfig.getBasePath();

class OrderService {

    getYourOrderV2(id) {
        return axiosInstance().get(path + "/orders/" + id);
    }

    // admin: shipping label + packing list (no prices)
    downloadDeliverySlip(id) {
        return axiosInstance().get(path + "/orders/admin/" + id + "/delivery-slip", {
            responseType: "blob"
        });
    }

    downloadBill(id) {
        return axiosInstance().get(path + "/orders/pdf/" + id, {
            responseType: "blob" 
        });
    }

    getOrderByAdmin(id) {
        return axiosInstance().get(path + "/orders/admin/" + id);
    }

    getYourOrdersListV2() {
        return axiosInstance().get(path + "/orders/all");
    }

    getAdminOrdersList(status) {
        return axiosInstance().get(path + "/orders/admin/all?status=" + status);
    }

    updateOrderStatus(orderId, status) {
        return axiosInstance().patch(path + "/orders/status?orderId=" + orderId + "&status=" + status);
    }

     updatePaymentConfirmation(formData) {
        return axiosInstance().post(path + "/payments/manual/callback", formData);
    }

    // payment methods the admin has switched on: { upi, card }; none → order on WhatsApp
    getPaymentMethods() {
        return axiosInstance().get(path + "/payments/methods");
    }

    // Razorpay Checkout, method 'upi' or 'card': amount is computed from the cart on the server
    // expectedTotal: the total the shopper saw; the server refuses (400) instead of charging a different amount
    createRazorpayOrder(method, expectedTotal) {
        return axiosInstance().post(path + "/payments/razorpay/create-order", { method: method.toUpperCase(), expectedTotal });
    }

    verifyRazorpayPayment(razorpayResponse) {
        return axiosInstance().post(path + "/payments/razorpay/verify", {
            razorpay_order_id: razorpayResponse.razorpay_order_id,
            razorpay_payment_id: razorpayResponse.razorpay_payment_id,
            razorpay_signature: razorpayResponse.razorpay_signature
        });
    }

    // no online gateway: the customer paid over WhatsApp and confirms "I have paid"
    confirmWhatsappOrder(expectedTotal) {
        return axiosInstance().post(path + "/payments/whatsapp/confirm", { expectedTotal });
    }

    getPaymentStatus(orderId) {
        return axiosInstance().get(path + "/payments/" + encodeURIComponent(orderId) + "/status");
    }

    // releases the items held for an unpaid attempt so other customers can buy them
    cancelPayment(orderId) {
        return axiosInstance().post(path + "/payments/" + encodeURIComponent(orderId) + "/cancel", {});
    }

}

export default new OrderService()